module.exports = __webpack_public_path__ + "img/magnifier.9ae222a8.svg";